export default {
    error: {
        'title': 'Error',
        'unknown': 'Server connect error',
        '1': 'Internal database error',
        '2': 'Got unknown command',
        '3': 'Got unknown format',
        '4': 'Wrong action',
        '5': 'Cannot login into the application (wrong login, password or missing user)',
        '6': 'Session does not exist or has expired',
        '7': 'Access denied (no permissions, no suitable license)',
        '8': 'Incorrect destination server',
        '9': 'Missing or cannot find the update server',
        '10': 'No session key',
        '11': 'No registration on the support server',
        '12': 'No registration on the support server - login is taken',
        '13': 'Sent data was lost',
        '14': 'The user is already registered in the HR network',
        '15': 'Too many people in the HR network',
        '16': 'Employee is not registered in the HR network',
        '17': 'Incorrect authentication key',
        '18': 'Data is not loaded',
        '19': 'Authentication key in link is unknown or expired',
        '20': 'This test project is completed',
        '21': 'Login is already registered',
        '22': 'Invalid login',
        '23': 'No default project',
        '24': 'Current script or test is not set',
        '25': 'Incorrect aspect ratio XML (SHL)',
        '26': 'Unknown method (SHL)',
        '27': 'There is no field with the result in XML(SHL)',
        '28': 'Empty result field in XML (SHL)',
        '29': 'XML field contains incorrect value of the result (SHL)',
        '30': 'No client code (SHL)',
        '31': 'Incorrect code Experium (SHL)',
        '32': 'No company code (SHL)',
        '33': 'No Experium code (SHL)',
        '34': 'No data of the result (SHL)',
        '35': 'No matching event (SHL)',
        '36': 'Internal Error: Invalid addAuthID in the URL',
        '37': 'Incorrect parameters in the URL',
        '38': 'Internal Error: Invalid authID in the URL',
        '39': 'Lifetime of link is expired',
        '40': 'Invalid object type',
        '41': 'Invalid object display mode',
        '42': 'No permissions to view the object',
        '43': 'Login has already been completed by another user',
        '44': 'Signed-in with a different type of user',
        '45': 'Dear user! You can not use the \'Web-interface\', because the user with the rights of \'Chief Administrator\' terminate your access to this service',
        '46': 'Web domain does not exist',
        '47': '<p>Dear user!</p><p>Web interface service not allowed for your company.</p><p>If you have any questions about adding or bying Web interface service, please contact our Experium customer department number +7(495) 783-66-03 (9:00&nbsp;–&nbsp;18:00 MSK)</p>',
        '48': 'Login parameters in web is not defined',
        '49': 'Employee with current email does not exist',
        '50': 'More then one employee with current email',
        '51': 'Too long password',
        '52': 'Too short password',
        '53': 'Invalid password',
        '54': 'Entered password is the same',
        '55': '<p>Dear user!</p><p>Web interface service not allowed or was not paid for your company.</p><p>If you have any questions about adding or bying Web interface service, please contact our Experium customer department number +7(495) 783-66-03 (9:00&nbsp;–&nbsp;18:00 MSK)</p>',
        '56': '\'Web-interface\' package is unavailable. Amount of purchased licenses exceeded the number of users of this package',
        '57': 'Old password is not identical to entered password',
        '60': 'No permissions',
        '80': 'Invalid file type',
        '141': 'Request was canceled',
        '255': 'Access is temporarily disabled. To unlock, enter a valid username, password, and characters from the image',
        'empty_document': 'Document is empty'
    },
    errors: {
        responsibleNotBlank: 'Choose an HR-manager',
        companyNotBlank:     'Choose a company',
        positionNotBlank:    'Enter the name of a position',
        quantityNotZero:     'Quantity must be more then zero',
        enterQuantity:       'Enter quantity',
        enterDate:           'Enter date',
        enterTime:           'Enter time',
        dateIsNotAfter:      'The entered date must not be later %(date)s',
        dateIsNotBefore:     'The entered date must not be earlier %(date)s',
        required:            'This is a required field',
        passwordLength:      'Password must be between 6 and 15 characters',
        passwordMustContain: 'Password must contain at least %(count)s digits and letters (latin)',
        passwordsMustMatch:  'Password confirmation does not match',
        lengthNotMoreThan:   'Not more than %(length)s symbols',
        valueNotLessThan:    'Not less than %(value)s',
        valueNotMoreThan:    'Not more than %(value)s',
        invalidSalaryValue:  'Invalid (valid example: 2000.50)',
        mustBeLessThan:      'Must be less than %(value)s',
        mustBeMoreThan:      'Must be more than %(value)s',
        mustBePositive:      'Must be greater than 0',
        notEnoughSymbols:    'The document cannot be saved because the required number of characters is not entered! %(currentCount)s/%(min)s',
        formNotSet:          'You must specify a form in the event constructor',
        notFound:            'Not found',
        dateInPast:          'Date in past',
        lessThanStartTime:   'End time is less than start time',
        incorrectDate:       'Incorrect date',
        incorrectTime:       'Incorrect time',
        incorrectEmail:      'Incorrect email',
        wrongFiletype:       'Format %(fileType)s is not allowed',
        incorrectInterval:   'Incorrect interval',
        exceededAllowedSize: 'Exceeded the allowed size (%(size)smb is maximum)',
        loadImageError:      'Load image error',
        emailError:          'Invalid email address',
        fileNotSelected:     'File not selected',
        '54':                'Entered password is the same',
        '57':                'Old password is not identical to entered password',
        '141':               'Request was canceled',
        'incorrect':         'Incorrect value',

        'licenseWillExpireSoon': '<div>Dear user!</div><div>End date of the paid period of use "web interface" Experium - <b>%(date)s</b>.</div><div>Using the "Web interface" after that date will be possible only after the payment of your company.</div><div>For any questions related to the payment and connecting to "Web Interface," a representative of your company can apply to the Experium sales department by phone +7 (495) 783-66-03.</div>',
        warning: 'Warning',
        couldNotOpenWindow: 'Could not open window',
        couldNotOpenSidebar: 'Could not open sidebar',
        couldNotOpenPage: 'Could not open page',
        toStartPage: 'To start page',
        matchDefault: 'The fields do not match',
        rangeDefault: 'Invalid field length',
        saveError: 'Save error',
        saveDocumentError: 'Could not upload the document',

        dateNotAllowed: {
            one: 'Event date can be correct only for one day',
            other: 'Event date can be correct only for %(count)s days',
        },
        subscribeError: 'Could not subscribe to notifications',
        notExistEvent: 'Event does not exist',
        dateIsNowOrBefore: 'The date can not exceed the current date',

        appError: 'Error in application run',
        'sso': 'Cant logon with domain',
        maxTextFieldLength: 'Maximum number of characters %(value)s'
    }
};
